export function resolveProductSearchThumbnailUrl(
  thumbnail: string | null | undefined,
  width: number,
  dpr = 2
) {
  const value = thumbnail?.trim()
  if (!value) return null

  const source = /^https?:\/\//i.test(value)
    ? value
    : `https://vinc.gumlet.io/gallery/thumbnails/${value}`
  const separator = source.includes('?') ? '&' : '?'
  return `${source}${separator}w=${width}&dpr=${dpr}`
}
